module.exports = __webpack_public_path__ + "img/152-kyrgyzstan.b7f9b2a5.svg";